import { Component } from '@angular/core';

@Component({
  selector: 'iq-error',
  templateUrl: './error.component.html',
  standalone: false
})
export class ErrorComponent {
  constructor() {}
}
